module.exports = __webpack_public_path__ + "static/logo-283a19cfaa3981043fd02ec707826087.png";